import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Calendar, ExternalLink } from 'lucide-react';
import { Button } from '../components/ui/button';
import { CALENDLY_URL } from '../lib/siteConfig';

export default function Book() {
  return (
    <div className="space-y-6" data-testid="book-page">
      <div>
        <div className="font-mono-accent uppercase tracking-[0.2em] text-[10px] text-[#004C54] font-semibold mb-2">
          Discovery Call
        </div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight">Book a Discovery Call with Coach Lewis</h1>
        <p className="text-[15px] text-foreground/70 mt-1 max-w-2xl">
          A 30-minute conversation to figure out two things: whether Coach Lewis currently has room for 1:1 work, and whether 1:1 is the right next step for where you're at. 1:1 coaching is intentionally limited so the athletes and families he takes on get his full focus. If it's not the right time or right fit, he'll point you to the resources that are.
        </p>
      </div>

      <Card className="border-border overflow-hidden" data-testid="calendly-embed-card">
        <CardContent className="p-0">
          <div className="bg-[#0a0d0e] px-5 sm:px-6 py-4 flex items-center justify-between gap-3">
            <div className="flex items-center gap-3 text-white">
              <div className="w-9 h-9 rounded-lg bg-[#004C54]/30 border border-[#004C54]/40 flex items-center justify-center">
                <Calendar className="h-4 w-4 text-[#4FBCC7]" />
              </div>
              <div>
                <div className="text-sm font-semibold">Coach Varsay Lewis</div>
                <div className="text-xs text-white/60">Mental Performance Consultant</div>
              </div>
            </div>
            <Button asChild variant="outline" size="sm" className="bg-transparent border-white/20 text-white hover:bg-white/10 hover:border-white/40">
              <a href={CALENDLY_URL} target="_blank" rel="noreferrer" data-testid="calendly-open-new-tab">
                Open in new tab
                <ExternalLink className="ml-1.5 h-3.5 w-3.5" />
              </a>
            </Button>
          </div>
          <iframe
            title="Book a session with Coach Lewis"
            src={`${CALENDLY_URL}?hide_landing_page_details=1&hide_gdpr_banner=1`}
            className="w-full h-[760px] sm:h-[820px] block bg-white"
            frameBorder="0"
            data-testid="calendly-iframe"
          />
        </CardContent>
      </Card>

      <div className="text-xs text-foreground/50 text-center">
        Having trouble with the embed?{' '}
        <a href={CALENDLY_URL} target="_blank" rel="noreferrer" className="underline hover:text-foreground" data-testid="calendly-fallback-link">
          Open Calendly directly
        </a>
        .
      </div>
    </div>
  );
}
